import { render, staticRenderFns } from "./NavDrawerGstc.vue?vue&type=template&id=38a3c1ff&scoped=true"
import script from "./NavDrawerGstc.vue?vue&type=script&lang=ts"
export * from "./NavDrawerGstc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a3c1ff",
  null
  
)

export default component.exports